import { useMemo, useState } from 'react';
import { ValidatorResponse } from '@connect-x-app/shared-utils';

type Response = {
  setDirty: () => void;
  showError: boolean;
};

export const useInputError = (validation?: ValidatorResponse): Response => {
  const [isDirty, setIsDirty] = useState(false);

  const showError = useMemo(() => {
    return !!(validation && !validation.isValid && validation.message && isDirty);
  }, [isDirty, validation]);

  return {
    setDirty: () => setIsDirty(true),
    showError,
  };
};
